import { Draft, PayloadAction } from '@reduxjs/toolkit';

import ICompanyEditRequestBody from 'services/httpClient/requests/company/ICompanyEditRequestBody';

import { IAuthData } from '../../initialState';

function editCompanySuccess(
  draft: Draft<IAuthData>,
  action: PayloadAction<ICompanyEditRequestBody>,
) {
  draft.editCompany.config.isLoading = false;
  draft.profile.address =
    action.payload.address.street + action.payload.address.number;
  draft.profile.zip = action.payload.zip;
  draft.profile.city = action.payload.city;
  draft.profile.website_url = action.payload.website;
  draft.profile.matching_locales = action.payload.mission_language;
  draft.profile.iban = action.payload.iban;
}

export default editCompanySuccess;
